/**
 * SidebarFooter.jsx — 사이드바 푸터 (2026-04-27 분리, 300줄 룰)
 *
 * 평소 모드: ⭐ 바로가기 등록 (모바일만) / 🔑 비밀번호 변경 / 🌙 다크 / 🚪 로그아웃
 * 편집 모드: ✓ 완료 (n/3) / ✕ 취소
 */
import React from 'react';
import { Star, Check, X as XIcon, KeyRound, Moon, Sun, LogOut } from 'lucide-react';
import { MAX_SHORTCUTS } from './shortcutHelpers';

const linkBtn = 'flex items-center gap-2.5 px-2.5 py-[7px] rounded-lg text-xs font-semibold w-full text-left border-none cursor-pointer bg-transparent transition-colors duration-100';

export default function SidebarFooter({
  editMode, selections, onSave, onCancel, // 편집 모드용
  isMobile, onStartEdit,                   // 평소 모드 — 바로가기 등록 (모바일만)
  onPasswordChange,
  isDark, toggleDark,
  onLogout,
}) {
  // mt-auto 는 데스크톱에서 푸터를 바닥에 붙인다. 모바일은 사이드바 전체가 한 덩어리로
  //   스크롤하므로(2026-09-21) 붙이지 않고 메뉴 다음에 자연스럽게 이어지게 둔다.
  return (
    <div className={isMobile ? 'px-2.5 pb-3' : 'px-2.5 pb-3 mt-auto'}>
      <div className="h-px bg-[var(--border)] mb-2" />
      {editMode ? (
        <>
          <button onClick={onSave} className="flex items-center justify-center gap-2 px-2.5 py-[8px] rounded-lg text-xs font-bold w-full border-none cursor-pointer bg-accent-500 hover:bg-accent-400 text-white transition-colors mb-1">
            <Check size={14} /><span>완료 ({selections.size}/{MAX_SHORTCUTS})</span>
          </button>
          <button onClick={onCancel} className={`${linkBtn} justify-center text-[var(--text-sub)] hover:bg-black/5 dark:hover:bg-white/5 hover:text-[var(--text)]`}>
            <XIcon size={14} /><span>취소</span>
          </button>
        </>
      ) : (
        <>
          {isMobile && (
            <button onClick={onStartEdit} className={`${linkBtn} text-[var(--text-sub)] hover:bg-black/5 dark:hover:bg-white/5 hover:text-[var(--text)]`}>
              <Star size={14} /><span>바로가기 등록</span>
            </button>
          )}
          {onPasswordChange && (
            <button onClick={onPasswordChange} className={`${linkBtn} text-[var(--text-sub)] hover:bg-black/5 dark:hover:bg-white/5 hover:text-[var(--text)]`}>
              <KeyRound size={14} /><span>비밀번호 변경</span>
            </button>
          )}
          <button onClick={toggleDark} className={`${linkBtn} text-[var(--text-sub)] hover:bg-black/5 dark:hover:bg-white/5 hover:text-[var(--text)]`}>
            {isDark ? <Sun size={14} /> : <Moon size={14} />}
            <span>{isDark ? '라이트 모드' : '다크 모드'}</span>
          </button>
          <button onClick={onLogout} className={`${linkBtn} text-red-500 dark:text-red-400 hover:bg-red-500/10 hover:text-red-600 dark:hover:text-red-300`}>
            <LogOut size={14} /><span>로그아웃</span>
          </button>
        </>
      )}
    </div>
  );
}
